import { defineMessages } from 'react-intl';

export default defineMessages({
    FirstName: {
        id: 'twia.quoteandbind.commercial.additionalInsured.First Name',
        defaultMessage: 'First Name',
    },
    LastName: {
        id: 'twia.quoteandbind.commercial.additionalInsured.Last Name',
        defaultMessage: 'Last Name',
    },
    saveFailedMsg: {
        id: 'twia.quoteandbind.commercial.additionalInsured.Save failed, please try again',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'twia.quoteandbind.commercial.additionalInsured.Can\'t Modify Contact',
        defaultMessage: 'Can\'t Modify Contact',
    },

});
